
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[workspaceId]",
      function () {
        return require("private-next-pages/[workspaceId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[workspaceId]"])
      });
    }
  